import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Button } from "../components/ui/button";
import { Printer, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { buildFullManualMarkdown } from "../lib/manual";

/**
 * Full manual on a single scrollable page — designed for browser-print/PDF export.
 * Users hit Cmd/Ctrl+P to save as PDF.
 */
export default function Manual() {
  const md = buildFullManualMarkdown();

  return (
    <div className="min-h-screen bg-background print:bg-white">
      {/* Print controls — hidden when printing */}
      <div className="print:hidden sticky top-0 z-10 bg-background/95 backdrop-blur border-b border-border">
        <div className="max-w-3xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-3">
          <Link to="/help" className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to Help
          </Link>
          <Button size="sm" onClick={() => window.print()} data-testid="manual-print-btn"
                  className="rounded-full bg-emerald-500 hover:bg-emerald-400 text-black font-semibold text-xs">
            <Printer className="w-3.5 h-3.5 mr-1.5" /> Save as PDF / Print
          </Button>
        </div>
      </div>

      <article
        data-testid="manual-body"
        className="max-w-3xl mx-auto px-4 md:px-8 py-8 prose prose-invert prose-lg print:prose-neutral print:max-w-none prose-headings:font-display prose-h1:text-4xl prose-h1:mb-4 prose-h1:mt-8 prose-h2:text-2xl prose-h2:mt-8 prose-h3:mt-6 prose-p:leading-relaxed prose-strong:text-foreground prose-a:text-emerald-400 prose-code:text-emerald-300 prose-code:bg-emerald-500/10 prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:before:content-none prose-code:after:content-none"
      >
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown>
        <footer className="mt-12 pt-6 border-t border-border/40 text-xs text-muted-foreground">
          © {new Date().getFullYear()} Aanar · aanar.org · Not financial advice
        </footer>
      </article>

      {/* Print-only overrides */}
      <style>{`
        @media print {
          html, body { background: #fff !important; color: #000 !important; }
          .prose { color: #000 !important; }
          .prose h1, .prose h2, .prose h3, .prose h4, .prose strong { color: #000 !important; }
          .prose a { color: #0E7C66 !important; }
          .prose code { background: #f3f4f6 !important; color: #0E7C66 !important; }
        }
      `}</style>
    </div>
  );
}
